import { render, staticRenderFns } from "./Queen.vue?vue&type=template&id=5fbc67ac&"
import script from "./Queen.vue?vue&type=script&lang=js&"
export * from "./Queen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports